export default "__VITE_ASSET__dNeCzhMU__"